/* Nexus theme — small, dependency-free script for the whole store */
(function () {
  'use strict';

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Drawers (menu + cart) ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    $$('[data-open="' + id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const f = $('button, a, input', $('.drawer-panel', d));
    if (f) setTimeout(() => f.focus(), 50);
    return true;
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach((d) => {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      $$('[data-open="' + d.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    });
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener && !document.body.classList.contains('template-cart')) {
      if (openDrawer(opener.dataset.open)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-close]')) closeDrawers();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeDrawers();
      $$('[data-nav-item].is-open').forEach(closeNav);
      closePredictive();
    }
  });

  /* ---------- Mega menu (click / keyboard; hover handled by CSS) ---------- */
  function closeNav(item) {
    item.classList.remove('is-open');
    const b = $('.nav-link', item);
    if (b) b.setAttribute('aria-expanded', 'false');
  }
  $$('[data-nav-item]').forEach((item) => {
    const btn = $('.nav-link', item);
    btn.addEventListener('click', () => {
      const open = item.classList.contains('is-open');
      $$('[data-nav-item].is-open').forEach(closeNav);
      if (!open) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
    item.addEventListener('mouseleave', () => closeNav(item));
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-nav-item]')) $$('[data-nav-item].is-open').forEach(closeNav);
  });

  /* ---------- Toast ---------- */
  let toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-show'), 2600);
  }

  /* ---------- Cart ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.dataset.count = count;
    });
  }
  async function refreshCartUI(sectionsHtml) {
    const html = sectionsHtml && sectionsHtml['cart-drawer'];
    const wrap = document.getElementById('shopify-section-cart-drawer');
    if (html && wrap) {
      const wasOpen = $('#CartDrawer.is-open');
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const fresh = $('#CartDrawer', tmp);
      if (fresh) {
        if (wasOpen) { fresh.classList.add('is-open'); fresh.setAttribute('aria-hidden', 'false'); }
        $('#CartDrawer').replaceWith(fresh);
      }
    }
    if (document.body.classList.contains('template-cart')) window.location.reload();
  }
  async function getJSON(url, opts) {
    const r = await fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts));
    const data = await r.json();
    if (!r.ok) throw data;
    return data;
  }
  async function changeLine(line, quantity) {
    const box = $('#CartDrawer .drawer-panel');
    if (box) box.classList.add('is-loading');
    try {
      const data = await getJSON(window.theme.routes.cartChange + '.js', {
        method: 'POST',
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: ['cart-drawer'], sections_url: window.location.pathname })
      });
      updateCount(data.item_count);
      await refreshCartUI(data.sections);
    } catch (err) {
      toast((err && err.description) || window.theme.strings.error);
    } finally {
      const b = $('#CartDrawer .drawer-panel');
      if (b) b.classList.remove('is-loading');
    }
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = $('[type="submit"]', form);
    if (btn) btn.setAttribute('aria-disabled', 'true');
    const fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    try {
      const r = await fetch(window.theme.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      const data = await r.json();
      if (!r.ok) throw data;
      const cart = await getJSON(window.theme.routes.cart + '.js');
      updateCount(cart.item_count);
      await refreshCartUI(data.sections);
      if (!openDrawer('CartDrawer')) toast(window.theme.strings.added);
    } catch (err) {
      toast((err && (err.description || err.message)) || window.theme.strings.error);
    } finally {
      if (btn) btn.removeAttribute('aria-disabled');
    }
  });

  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-remove]');
    if (rm) { changeLine(rm.dataset.remove, 0); return; }
    const step = e.target.closest('[data-qty-change]');
    if (step) {
      const input = $('input', step.closest('[data-qty]'));
      if (!input) return;
      const min = input.min !== '' ? Number(input.min) : 1;
      let val = Math.max(min, Number(input.value || 0) + Number(step.dataset.qtyChange));
      if (input.max) val = Math.min(val, Number(input.max));
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (input) changeLine(input.dataset.lineQty, input.value);
  });

  /* ---------- Predictive search ---------- */
  const searchForm = $('[data-predictive]');
  let pTimer, pAbort;
  function closePredictive() {
    const box = $('[data-predictive-results]');
    if (box) { box.classList.remove('is-open'); }
    const inp = searchForm && $('input[type="search"]', searchForm);
    if (inp) inp.setAttribute('aria-expanded', 'false');
  }
  if (searchForm) {
    const input = $('input[type="search"]', searchForm);
    const box = $('[data-predictive-results]', searchForm);
    input.addEventListener('input', () => {
      clearTimeout(pTimer);
      const q = input.value.trim();
      if (q.length < 2) { closePredictive(); return; }
      pTimer = setTimeout(async () => {
        if (pAbort) pAbort.abort();
        pAbort = new AbortController();
        try {
          const url = window.theme.routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor,tag';
          const r = await fetch(url, { signal: pAbort.signal });
          const text = await r.text();
          const tmp = document.createElement('div');
          tmp.innerHTML = text;
          const inner = $('[data-predictive-inner]', tmp);
          box.innerHTML = inner ? inner.innerHTML : '';
          box.classList.toggle('is-open', !!inner);
          input.setAttribute('aria-expanded', inner ? 'true' : 'false');
        } catch (err) { /* aborted */ }
      }, 220);
    });
    input.addEventListener('keydown', (e) => {
      const links = $$('a', box);
      if (!links.length || !box.classList.contains('is-open')) return;
      const i = links.findIndex((a) => a.getAttribute('aria-selected') === 'true');
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (i > -1) links[i].removeAttribute('aria-selected');
        const n = e.key === 'ArrowDown' ? (i + 1) % links.length : (i - 1 + links.length) % links.length;
        links[n].setAttribute('aria-selected', 'true');
        links[n].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && i > -1) {
        e.preventDefault();
        window.location.href = links[i].href;
      }
    });
    document.addEventListener('click', (e) => { if (!e.target.closest('[data-predictive]')) closePredictive(); });
  }

  /* ---------- Store hours: highlight today + open now (Pacific time) ---------- */
  function pacificNow() {
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
    const get = (t) => (parts.find((p) => p.type === t) || {}).value;
    const days = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return { day: days[get('weekday')], mins: (Number(get('hour')) % 24) * 60 + Number(get('minute')) };
  }
  const toMins = (s) => { const [h, m] = s.trim().split(':'); return Number(h) * 60 + Number(m || 0); };
  try {
    const now = pacificNow();
    $$('[data-hours] tr[data-day="' + now.day + '"]').forEach((tr) => tr.classList.add('is-today'));
    const row = $('[data-hours] tr[data-day="' + now.day + '"]');
    $$('[data-open-badge]').forEach((badge) => {
      let open = false;
      if (row && row.dataset.hoursRange.includes('-')) {
        const [a, b] = row.dataset.hoursRange.split('-');
        open = now.mins >= toMins(a) && now.mins < toMins(b);
        badge.textContent = open ? 'Open now · until ' + $('td:last-child', row).textContent.split('–')[1].trim() : 'Closed now';
      } else {
        badge.textContent = 'Closed today';
      }
      badge.classList.add(open ? 'is-open' : 'is-closed');
    });
  } catch (err) { /* ignore */ }

  /* ---------- Collection filters & sorting (no page reload) ---------- */
  function initFacets() {
    const form = $('[data-facets-form]');
    const sort = $('[data-sort]');
    async function apply(params) {
      const grid = $('[data-coll-results]');
      if (grid) grid.classList.add('is-loading');
      const url = window.location.pathname + '?' + params.toString();
      const sectionId = $('[data-section-id]') && $('[data-section-id]').dataset.sectionId;
      try {
        const r = await fetch(url + (params.toString() ? '&' : '') + 'section_id=' + sectionId);
        const html = await r.text();
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const fresh = $('[data-coll-root]', tmp);
        const cur = $('[data-coll-root]');
        const wasOpen = $('#FacetsWrap.is-open');
        if (fresh && cur) cur.replaceWith(fresh);
        if (wasOpen && $('#FacetsWrap')) $('#FacetsWrap').classList.add('is-open');
        history.replaceState({}, '', url);
        initFacets();
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-facets-open]')) { const w = $('#FacetsWrap'); if (w) { w.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
    if (e.target.closest('[data-facets-close]')) { const w = $('#FacetsWrap'); if (w) { w.classList.remove('is-open'); document.body.style.overflow = ''; } }
  });
      } catch (err) {
        window.location.href = url;
      }
    }
    function collect() {
      const params = new URLSearchParams();
      const f = $('[data-facets-form]');
      if (f) new FormData(f).forEach((v, k) => { if (v !== '') params.append(k, v); });
      if (sort && sort.value) params.set('sort_by', sort.value);
      return params;
    }
    $$('[data-facets-form]').forEach((f) => {
      f.addEventListener('change', () => apply(collect()));
      f.addEventListener('submit', (e) => { e.preventDefault(); apply(collect()); });
    });
    if (sort) sort.addEventListener('change', () => apply(collect()));
    $$('[data-facet-link]').forEach((a) => a.addEventListener('click', (e) => {
      e.preventDefault();
      const u = new URL(a.href, window.location.origin);
      u.searchParams.delete('section_id');
      apply(u.searchParams);
    }));
  }
  initFacets();

  window.Nexus = { openDrawer, closeDrawers, toast };
})();
